/* eslint-disable react/style-prop-object */
import React from 'react';
import Button from 'shared/components/Buttons/Button';

const NakedButton = props => <Button {...props} variant="naked" />;

export default NakedButton;
